import React, { ReactNode } from 'react';

interface SectionProps {
  title?: string;
  subtitle?: string;
  id?: string;
  children: ReactNode;
  className?: string;
  titleColor?: string;
  subtitleColor?: string;
}

const Section: React.FC<SectionProps> = ({ 
  title, 
  subtitle, 
  id, 
  children, 
  className = "bg-white", 
  titleColor = "text-gray-900",
  subtitleColor = "text-gray-500"
}) => {
  return (
    <section id={id} className={`py-24 md:py-32 px-6 relative ${className}`}>
      <div className="container mx-auto max-w-6xl relative z-10">
        {(title || subtitle) && (
          <div className="mb-16 md:mb-24 text-center max-w-2xl mx-auto">
            {title && <h2 className={`font-serif text-4xl md:text-5xl font-bold mb-6 ${titleColor}`}>{title}</h2>}
            {subtitle && <p className={`text-lg leading-relaxed ${subtitleColor}`}>{subtitle}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section;